module.exports = __webpack_public_path__ + "static/img/MV15.caba340.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV15.jpg
// module id = nWe9
// module chunks = 0